import React from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import { LEGAL_TEXTS } from "@/legal/content";

// Single component that serves /terms, /privacy, /cookies. The URL param
// picks which document to render.
export default function LegalPage() {
  const { doc } = useParams();
  const { i18n } = useTranslation();
  const key = LEGAL_TEXTS[doc] ? doc : "terms";
  const lang = i18n.language === "en" ? "en" : "it";
  const md = LEGAL_TEXTS[key][lang];

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-[900px] mx-auto px-6 lg:px-10 py-10 relative z-10">
        <Link
          to="/"
          className="btn-ghost text-sm inline-flex items-center gap-2 !py-2 !px-3 mb-6"
          data-testid="legal-back-home"
        >
          <ArrowLeft size={14} /> Home
        </Link>
        <article
          className="prose prose-invert prose-headings:font-display max-w-none
                     prose-h1:text-4xl prose-h1:mb-8
                     prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-h2:text-[color:var(--brand)]
                     prose-p:text-[color:var(--fg-secondary)]
                     prose-li:text-[color:var(--fg-secondary)]
                     prose-strong:text-white
                     prose-table:text-sm prose-th:text-white prose-td:text-[color:var(--fg-secondary)]
                     prose-a:text-[color:var(--brand)]"
          data-testid={`legal-content-${key}`}
        >
          <ReactMarkdown>{md}</ReactMarkdown>
        </article>
      </main>
    </div>
  );
}
